import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const CustomizationOptions = ({ currentAccessory, onAccessoryChange }) => {
  const { t } = useLanguage();

  const accessories = [
    { id: 'none', name: t('accessories.none'), icon: '🚫' },
    { id: 'crown', name: t('accessories.crown'), icon: '👑' },
    { id: 'star', name: t('accessories.star'), icon: '⭐' },
    { id: 'heart', name: t('accessories.heart'), icon: '💖' },
    { id: 'music', name: t('accessories.music'), icon: '🎵' },
    { id: 'glasses', name: t('accessories.glasses'), icon: '👓' },
    { id: 'bowtie', name: t('accessories.bowtie'), icon: '🎀' },
    { id: 'hat', name: t('accessories.hat'), icon: '🎩' }
  ];

  return (
    <div className="grid grid-cols-2 gap-3">
      {accessories.map(accessory => (
        <button
          key={accessory.id}
          onClick={() => onAccessoryChange(accessory.id)}
          className={`p-4 rounded-xl font-medium transition-all duration-200 hover:scale-105 ${
            currentAccessory === accessory.id
              ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg'
              : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600'
          }`}
        >
          <div className="text-2xl mb-2">{accessory.icon}</div>
          <div className="text-sm">{accessory.name}</div>
        </button>
      ))}
    </div>
  );
};

export default CustomizationOptions;